import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-down-for-maintenance',
  templateUrl: './down-for-maintenance.component.html',
  styleUrls: ['./down-for-maintenance.component.scss']
})
export class DownForMaintenanceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
